import React from 'react'
import { Row, Col, Typography, Card } from 'antd'
import { EmptyHeaderHero, GlobalHeader, GlobalFooter } from './components'

const { Link, Text, Title } = Typography

const PolicyInactive = () => {
    return (
        <div className="container">
            {/* <GlobalHeader /> */}
            <>
                <EmptyHeaderHero leftAlign={true} minHeight={true} title="Policy Inactive" />
                <div className="express-policy-changes">
                    <Row>
                        <Card className="register-card">
                            <Title style={{color: "black", fontSize: "24px", margin: "12px 0px", fontWeight: 400}}>Our records indicate that this Username / Email Address is associated with an inactive policy.</Title>
                            <Title style={{color: "black", fontSize: "24px", margin: "12px 0px", fontWeight: 400}}>Please call <a href="tel:+18005352873">800-535-2873</a> for assistance.</Title>
                            <Title style={{color: "black", fontSize: "24px", margin: "12px 0px", fontWeight: 400}}>Don&#39;t worry! Your password and security questions have been saved for future use once the policy issue is resolved.</Title>
                        </Card>
                    </Row>
                </div>
            </>
            {/* <GlobalFooter /> */}
        </div>
    )
}

PolicyInactive.propTypes = {}
export default PolicyInactive
